/**
 * Base URL for API requests.
 * Reads from .env:
 *   - NEXT_PUBLIC_APP_ENV: 'development' | 'staging' | 'production'
 *   - NEXT_PUBLIC_BACKEND_URL_DEVELOPMENT
 *   - NEXT_PUBLIC_BACKEND_URL_STAGING
 *   - NEXT_PUBLIC_BACKEND_URL_PRODUCTION
 *
 * Note: Create React App only exposes env vars prefixed with REACT_APP_.
 * If using CRA, either rename the vars in .env to REACT_APP_APP_ENV and
 * REACT_APP_BACKEND_URL_*, or use craco/react-app-rewired to expose NEXT_PUBLIC_*.
 */


function getBaseUrl() {
  const appEnv = (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_APP_ENV) || process.env?.REACT_APP_APP_ENV || 'production';

  let url;
  switch (appEnv) {
    case 'production':
      url = process.env?.NEXT_PUBLIC_BACKEND_URL_PRODUCTION || process.env?.REACT_APP_BACKEND_URL_PRODUCTION || 'https://dev.opencallforartists.com';
      break;
    case 'staging':
      url = process.env?.NEXT_PUBLIC_BACKEND_URL_STAGING || process.env?.REACT_APP_BACKEND_URL_STAGING || 'https://dev.staging.opencallforartists.com';
      break;
    case 'development':
    default:
      url = process.env?.NEXT_PUBLIC_BACKEND_URL_DEVELOPMENT || process.env?.REACT_APP_BACKEND_URL_DEVELOPMENT || 'http://127.0.0.1:8000';
      break;
  }

  const base = url.endsWith('/') ? url.slice(0, -1) : url;
  return `${base}/admin_panel/`;
}

export const BASEURL = getBaseUrl();
